<template>
    <div id="show">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-th-list"></i> Categories</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
                <div class="field">
                  <label class="label">Id:</label>
                  <div class="control">
                    <span>{{item.id}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Alias:</label>
                    <div class="control">
                        <span>{{item.alias}}</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                  <label class="label">Title:</label>
                  <div class="control">
                    <span>{{item.title}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Placeholder:</label>
                    <div class="control">
                        <span>{{item.placeholder}}</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Description:</label>
                    <div class="control">
                        <span>{{item.description}}</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Field type:</label>
                    <div class="control">
                        <span>{{item.type}}</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Schools:</label>
                    <div class="control" v-if="!item.schools">All schools</div>
                    <div v-else class="control" v-for="school in item.schools">
                        <p>{{school.name}}</p>
                    </div>
                </div>
            </div>

            <div class="column is-2 is-offset-8 is-pulled-right"> 
                <router-link v-bind:to="{ name: 'magic-word-edit', params: { id: item.id }}" class="button is-block is-warning">
                    Edit
                </router-link>                
            </div>
            <div class="column is-2 is-pulled-right"> 
                <a href="javascript:history.go(-1)" class="button is-block">
                    Back
                </a>                
            </div>                        
        </div>          
    </div>  
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'magic-word-show',
  components: {},
  data() {
        return {
            item: {},
        }
  },
  created(){  
    this.getMagicWord(this.$route.params.id);
  },
  methods: {
      getMagicWord(id){
        this.magicWordRepo.get(id).then(response => {
            this.item = response.data.data;
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/magic-words/Show.vue